module.exports = __webpack_public_path__ + "static/media/piano5.cc75c2e3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/game/scene1/asset/piano5.mp3
// module id = 1785
// module chunks = 0